import { call, put, takeEvery } from 'redux-saga/effects';
import { bikeFind } from '../../requests/bike_find_request';
import { FIND_BIKE_REQUEST } from '../constants/find_bike.constants';

function* findBikeRequest({ vrm }) {
    yield put({
        type: 'SET_LEAD_CREATE_DATA',
        payload: {
            bike_info_by_vrm: {
                loading: true,
                data: {},
            },
        },
    });

    const bike_info_by_vrm = yield call(bikeFind, vrm);

    if (bike_info_by_vrm.experian) {
        const payload = {
            bike_info_by_vrm: {
                loading: false,
                showModal: true,
                data: bike_info_by_vrm,
                chassisNumber: String(bike_info_by_vrm.experian.vinSerialNumber).trim(),
                make: bike_info_by_vrm.experian.make,
                model: bike_info_by_vrm.model
            },
        };

        yield put({ type: 'SET_LEAD_CREATE_DATA', payload });
    } else {
        yield put({
            type: 'SET_LEAD_CREATE_DATA',
            payload: {
                bike_info_by_vrm: {
                    loading: false,
                    showModal: true,
                    error: bike_info_by_vrm.error,
                    data: {},
                },
            },
        });
    }
}

export default function* findBikeSaga() {
    yield takeEvery(FIND_BIKE_REQUEST, findBikeRequest);
}

function returnYearCode(bike) {
    if (bike.toLowerCase().includes('honda')) {
        if (bike.includes('F-2')) {
            return 'F-2';
        }
        if (bike.includes('F-3')) {
            return 'F-3';
        }
        if (bike.includes('F-4')) {
            return 'F-4';
        }
        if (bike.includes('F-5')) {
            return 'F-5';
        }
        if (bike.includes('F-6')) {
            return 'F-6';
        }
        if (bike.includes('F-7')) {
            return 'F-7';
        }
        if (bike.includes('F-8')) {
            return 'F-8';
        }
    }

    if (bike.toLowerCase().includes('suzuki')) {
        if (bike.includes('K1')) {
            return 'K1';
        }
        if (bike.includes('K2')) {
            return 'K2';
        }
        if (bike.includes('K3')) {
            return 'K3';
        }
        if (bike.includes('K4')) {
            return 'K4';
        }
        if (bike.includes('K5')) {
            return 'K5';
        }
        if (bike.includes('K6')) {
            return 'K6';
        }
        if (bike.includes('K7')) {
            return 'K7';
        }
        if (bike.includes('K8')) {
            return 'K8';
        }
        if (bike.includes('K9')) {
            return 'K9';
        }
        if (bike.includes('L0')) {
            return 'L0';
        }
        if (bike.includes('L1')) {
            return 'L1';
        }
        if (bike.includes('L2')) {
            return 'L2';
        }
        if (bike.includes('L3')) {
            return 'L3';
        }
        if (bike.includes('L4')) {
            return 'L4';
        }
        if (bike.includes('L5')) {
            return 'L5';
        }
        if (bike.includes('L6')) {
            return 'L6';
        }
        if (bike.includes('L7')) {
            return 'L7';
        }
        if (bike.includes('L8')) {
            return 'L8';
        }
        if (bike.includes('L9')) {
            return 'L9';
        }
    }

    return '';
}



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_create/redux/sagas/find_bike.saga.js